import React from "react";

import moment from "moment";
import { useParams } from "react-router-dom";

import { TIME_FORMAT_SHORT } from "../../../constants/dateFormat";
import { FAST_CHANNELS_ROUTE } from "../../routes/routes";
import Tag, { SIZES_TAG } from "../../tag/Tag";
import AbilityLink from "../../utils/abilities/AbilityLink";

import type { JSX } from "react";

import type { ScheduleTimeslotDetails } from "../../../api/FastAPI.types";
import type { FASTChannelRoutesParams } from "../../routes/FASTChannelRoutes";

interface Props {
  timeslotList: ScheduleTimeslotDetails[];
  canAccessfastChannelsWrite: boolean;
}

function CalendarDaySidepanelTimeslotList({
  timeslotList,
  canAccessfastChannelsWrite,
}: Props): JSX.Element {
  const params = useParams<FASTChannelRoutesParams>();
  const { channelId } = params;
  return (
    <div className="border-border bg-muted flex flex-col gap-[0.625rem] rounded-[0.3125rem] border p-[0.625rem]">
      {timeslotList?.map((timeslot) => (
        <div key={timeslot.uuid} className="flex">
          <div className="my-auto w-[8.125rem]">{`${moment(timeslot.start_time).format(TIME_FORMAT_SHORT)} - ${moment(timeslot.end_time).format(TIME_FORMAT_SHORT)}`}</div>
          <AbilityLink
            canAccess={canAccessfastChannelsWrite}
            className="w-full truncate"
            rel="noopener noreferrer"
            target="_blank"
            to={`${FAST_CHANNELS_ROUTE}/${channelId}/timeslots/${timeslot.uuid}`}
          >
            <Tag isFullWidth color={timeslot.color} size={SIZES_TAG.MEDIUM}>
              {timeslot.name}
            </Tag>
          </AbilityLink>
        </div>
      ))}
    </div>
  );
}

export default CalendarDaySidepanelTimeslotList;
